import * as React from "react";
import { IconProps } from "./types";

export const ChevronUpDoubleIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M17 18L12 13L7 18M17 11L12 6L7 11"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ChevronUpDoubleIcon as React.FunctionComponent).displayName =
  "ChevronUpDoubleIcon";

export default ChevronUpDoubleIcon;
